// Interface

import util from '@/utils/classToObject'
import { IClientState } from './state'

export class ClientGetter {
    
    public panier(state: IClientState) {
        return state.panier
    }
    
}

export default util.classToObject(ClientGetter)